// Function to get industry types with translations
export const getIndustryTypes = (t) => [
  {title: t('constants.industryTypes.agriculture'), value: "agriculture", icon: "mdi-pig-variant", color: "indufastYellow"},
  {title: t('constants.industryTypes.industries'), value: "industries", icon: "mdi-factory", color: "indufastRed"},
  {title: t('constants.industryTypes.automotive'), value: "automotive", icon: "mdi-car-side", color: "indufastGreen"},
  {title: t('constants.industryTypes.car_wash'), value: "car_wash", icon: "mdi-car-wash", color: "indufastBlue"},
];

// Function to get employee types with translations
export const getEmployeeTypes = (t) => [
  {title: t('constants.employeeTypes.staff'), value: "staff"},
  {title: t('constants.employeeTypes.subcontractor'), value: "subcontractor"},
];

// Function to get employee availability with translations
export const getEmployeeAvailability = (t) => [
  {title: t('constants.employeeAvailability.unknown'), value: "unknown", icon: "mdi-help-circle-outline", color: "grey"},
  {title: t('constants.employeeAvailability.available'), value: "available", icon: "mdi-check-circle", color: "indufastGreen"},
  {title: t('constants.employeeAvailability.available_morning_afternoon'), value: "available_morning_afternoon", icon: "mdi-check-circle-outline", color: "indufastYellow"},
  {title: t('constants.employeeAvailability.available_morning'), value: "available_morning", icon: "mdi-weather-sunset-up", color: "indufastYellow"},
  {title: t('constants.employeeAvailability.available_afternoon'), value: "available_afternoon", icon: "mdi-weather-sunset-down", color: "indufastBlue"},
  {title: t('constants.employeeAvailability.not_available'), value: "not_available", icon: "mdi-alert-circle", color: "indufastRed"},
  {title: t('constants.employeeAvailability.not_available_non_working_day'), value: "not_available_non_working_day", icon: "mdi-briefcase-variant-off-outline", color: "indufastPurple"},
  {title: t('constants.employeeAvailability.not_available_absent'), value: "not_available_absent", icon: "mdi-account-off", color: "indufastRed"},
  {title: t('constants.employeeAvailability.not_available_error'), value: "not_available_error", icon: "mdi-alert-circle-outline", color: "indufastOrange"},
];

// Function to get project status with translations
export const getProjectStatus = (t) => [
  {title: t('constants.projectStatus.planning'), value: "planning", color: "indufastBlue"},
  {title: t('constants.projectStatus.incomplete'), value: "incomplete", color: "indufastRed"},
  {title: t('constants.projectStatus.weather_dependent'), value: "weather_dependent", color: "indufastOrange"},
  {title: t('constants.projectStatus.complete'), value: "complete", color: "indufastGreen"},
  {title: t('constants.projectStatus.unplanned'), value: "unplanned", color: "indufastPurple"},
];

// Function to get budget assessments with translations
export const getBudgetAssessments = (t) => [
  {title: t('budget.assessment.met'), value: "met", color: "success"},
  {title: t('budget.assessment.notMet'), value: "notMet", color: "error"},
  {title: t('budget.assessment.noBudget'), value: "noBudget", color: "grey"},
  {title: t('budget.assessment.noWorkdays'), value: "noWorkdays", color: "grey"},
  {title: t('budget.assessment.unprocessedWorkdays'), value: "unprocessedWorkdays", color: "warning"},
];

// Function to get event types with translations
export const getEventType = (t) => [
  {title: t('constants.eventType.work'), value: "work", color: "black"},
  {title: t('constants.eventType.blast'), value: "blast", color: "indufastOrange"},
  {title: "Container plaatsen", value: "container_drop", color: "teal"},
  {title: "Container ophalen", value: "container_pickup", color: "brown"},
];

export const getSpecialEventConfig = (t) => ({
  blast: {
    label: t('constants.specialEventType.blast.label'),
    displayLabel: t('constants.specialEventType.blast.displayLabel'),
    icon: 'mdi-handshake',
    color: 'orange-darken-2',
    textClass: 'text-orange-darken-2',
    markerColor: 'orange',
    markerTooltip: t('constants.specialEventType.blast.markerTooltip'),
    hasConfirmed: true,
  },
  container_drop: {
    label: t('constants.specialEventType.container_drop.label'),
    displayLabel: t('constants.specialEventType.container_drop.displayLabel'),
    icon: 'mdi-package-variant',
    color: 'teal-darken-2',
    textClass: 'text-teal-darken-2',
    markerColor: 'teal',
    markerTooltip: t('constants.specialEventType.container_drop.markerTooltip'),
    hasConfirmed: true,
  },
  container_pickup: {
    label: t('constants.specialEventType.container_pickup.label'),
    displayLabel: t('constants.specialEventType.container_pickup.displayLabel'),
    icon: 'mdi-package-variant-closed-remove',
    color: 'brown-darken-2',
    textClass: 'text-brown-darken-2',
    markerColor: 'brown',
    markerTooltip: t('constants.specialEventType.container_pickup.markerTooltip'),
    hasConfirmed: true,
  },
  overnight: {
    label: t('constants.specialEventType.overnight.label'),
    displayLabel: t('constants.specialEventType.overnight.displayLabel'),
    icon: 'mdi-bed',
    color: 'indigo-darken-2',
    textClass: 'text-indigo-darken-2',
    markerColor: 'indigo',
    markerTooltip: t('constants.specialEventType.overnight.markerTooltip'),
    hasConfirmed: true,
    isRange: true,
  },
});

// Function to get user groups with translations
export const getUserGroups = (t) => [
  {title: t('constants.userGroups.SUPERADMIN'), value: "SUPERADMIN"},
  {title: t('constants.userGroups.ADMIN'), value: "ADMIN"},
  {title: t('constants.userGroups.VIEWER'), value: "VIEWER"},
  {title: t('constants.userGroups.EMPLOYEE'), value: "EMPLOYEE"},
];

export const specialHoursTypes = [
  {value: 'leave', title: 'Verlof'},
  {value: 'special-leave', title: 'Bijzonder verlof'},
  {value: 'sick', title: 'Ziek'},
  {value: 'unexcused-leave', title: 'Ongeoorloofd afwezig'},
  {value: 'holiday', title: 'Feestdag'},
  {value: 'collective-leave', title: 'Collectief verlof'},
];

export const holidayTypeColors = {
  legal_holiday: 'indufastGreen',
  collective_leave: 'indufastCyan',
  closing_day: 'indufastGrey',
};

export const specialHoursTypeColors = {
  leave: 'indufastBlue',
  'special-leave': 'indufastBlue',
  sick: 'indufastBlue',
  'unexcused-leave': 'indufastBlue',
  holiday: 'indufastGreen',
  'collective-leave': 'indufastCyan',
};

export const themeTintStyle = (color) =>
  color ? {backgroundColor: `rgba(var(--v-theme-${color}), var(--v-extra-light-opacity))`} : null;

export const debounceMseconds = 750;

export const firstSelectableDate = new Date(2024, 0, 1);

export const budgetPeriods = ['week', 'month', 'year'];
export const defaultBudgetPeriod = 'month';

// Function to get holiday display names with translations
export const getHolidayDisplayNames = (t) => ({
  'nieuwjaar': t('constants.holidays.nieuwjaar'),
  'pasen': t('constants.holidays.pasen'),
  'paas_maandag': t('constants.holidays.paas_maandag'),
  'koningsdag': t('constants.holidays.koningsdag'),
  'bevrijdingsdag': t('constants.holidays.bevrijdingsdag'),
  'hemelvaart': t('constants.holidays.hemelvaart'),
  'pinksteren': t('constants.holidays.pinksteren'),
  'pinkster_maandag': t('constants.holidays.pinkster_maandag'),
  'kerstmis': t('constants.holidays.kerstmis'),
  'tweedekerstdag': t('constants.holidays.tweedekerstdag'),
});

// Function to get non-working days with translations
export const getNonWorkingDays = (t) => ({
  'monday': t('days.monday'),
  'tuesday': t('days.tuesday'),
  'wednesday': t('days.wednesday'),
  'thursday': t('days.thursday'),
  'friday': t('days.friday'),
  'saturday': t('days.saturday'),
  'sunday': t('days.sunday'),
});

// Function to get non-working days with translations
export const getMaterialChecks = (t) => ({
  'correct_material': t('material.check.correct_material'),
  'correct_quantity': t('material.check.correct_quantity'),
  'packing_not_damaged': t('material.check.packing_not_damaged'),
  'product_not_damaged': t('material.check.product_not_damaged'),
  'order_number_checked': t('material.check.order_number_checked'),
  'expiry_date_checked': t('material.check.expiry_date_checked'),
  'material_safe_for_usage': t('material.check.material_safe_for_usage'),
});

// Function to get the push notification states with translations
export const getPushNotificationStates = (t) => ({
  unsupported: {type: "warning", message: t('notifications.unsupported')},
  install: {type: "info", title: t('notifications.installTitle'), message: t('notifications.installIos')},
  denied: {type: "warning", message: t('notifications.denied')},
  linked: {type: "success", message: t('notifications.enabled')},
  notLinked: {type: "info", message: t('notifications.notEnabled')},
});

export const plannable = {
  PLANNABLE: 'plannable',
  NOT_PLANNABLE_INTERNAL: 'not_plannable_internal',
  NOT_PLANNABLE_EXTERNAL: 'not_plannable_external',
 };

 const employeeFieldLabels = {
   'name': 'Naam',
   'name_accredis': 'Naam in Accredis',
   'type': 'Type',
   'email': 'E-mail',
   'extra_email': 'Extra e-mail',
   'rank': 'Rang',
   'rank_number': 'Rangnummer',
   'industries': 'Branches',
   'private': 'Privé',
   'team_lead': 'Contactpersoon bouwplaats',
   'active': 'Actief',
   'may_login': 'Mag inloggen',
   'usergroup': 'Gebruikersgroep',
   'monthly_percentage': 'Maandpercentage',
   'non_working_days_even_weeks': 'Roostervrije dagen (even weken)',
   'non_working_days_uneven_weeks': 'Roostervrije dagen (oneven weken)',
   'start_date': 'Startdatum',
   'end_date': 'Einddatum',
   'no_overnight_stays': 'Liever niet overnachten',
   'location_id': 'Locatie',
 };

 const projectFieldLabels = {
   'name': 'Naam',
   'status': 'Status',
   'remark': 'Omschrijving',
   'fte': 'FTE',
   'project_number': 'Projectnummer',
   'project_number_exact': 'Projectnummer Exact',
   'customer_name': 'Klantnaam',
   'contact_name': 'Contactpersoon',
   'contact_email': 'E-mailadres contactpersoon',
   'contact_number': 'Telefoonnummer contactpersoon',
   'address': 'Adres',
   'material_load': 'Materiaal laden',
 };

  const projectPurchaseOrderFieldLabels = {
    'delivery_date': 'Leverdatum',
    'order_number': 'Ordernummer',
    'suppliers': 'Leveranciers',
  };

  const workdayFieldLabels = {
   'break_time': 'Pauzetijd',
   'work_time': 'Werktijd',
   'date': 'Datum',
   'travel_to_end_line_id': 'Reistijd heen',
   'travel_from_start_line_id': 'Reistijd terug',
   'travel_to_time': 'Duur heenreis',
   'travel_to_distance': 'Kilometers heenreis',
   'travel_from_time': 'Duur terugreis',
   'travel_from_distance': 'Kilometers terugreis',
   'too_late': 'Te laat',
   'type': 'Type',
   'remark': 'Opmerking',
   'start': 'Start',
   'end': 'Eind',
   'duration': 'Duur',
 };

 const workdayLineFieldLabels = {
   'start': 'Start',
   'end': 'Eind',
   'type': 'Type',
   'remark': 'Opmerking',
   'void': 'Verwijderd',
   'travel_to': 'Reistijd heen',
   'travel_from': 'Reistijd terug',
   'distance': 'Afstand',
   'start_address': 'Startadres',
   'end_address': 'Eindadres',
   'vehicle': 'Voertuig',
 };

 const workdaySummaryFieldLabels = {
   'year': 'Jaar',
   'month': 'Maand',
   'employee_id': 'Medewerker',
   'monthly_balance': 'Maandelijkse saldo',
   'locked': 'Vastgesteld',
 };

 const calendarEventFieldLabels = {
   'start': 'Start',
   'end': 'Eind',
   'type': 'Type',
   'remark': 'Opmerking',
   'team_lead_employee_id': 'Contactpersoon bouwplaats',
   'fte': 'FTE',
   'confirmed': 'Bevestigd',
 };

 const genericLabels = {
   'name': 'Naam',
   'remark': 'Opmerking',
   'true': 'Ja',
   'false': 'Nee',
   'new': 'Nieuw',
   'processed': 'Afgerond',
   'employee_id': 'Medewerker',
 };

 const entityLabels = {
   'IndufastEmployee': 'Medewerker',
   'IndufastProject': 'Project',
   'IndufastProjectPurchaseOrder': 'Inkooporder',
   'IndufastWorkday': 'Werkdag',
   'IndufastWorkdayLine': 'Rit',
   'IndufastCalendarEvent': 'Projectdag',
   'IndufastWorkdaySpecialHours': 'Bijzondere uren',
   'IndufastCalendarEventEmployee': 'Ingeplande medewerker',
   'IndufastCountry': 'Land',
   'IndufastHoliday': 'Bijzondere dag',
   'IndufastLocation': 'Locatie',
 };

 const countryHolidayFieldLabels = {
   'code': 'Landcode',
   'country_id': 'Land',
   'year': 'Jaar',
   'date': 'Datum',
   'legal_holiday': 'Feestdag',
   'collective_leave': 'Collectief verlof',
   'closing_day': 'Sluitingsdag',
 };

 const arrayToLabels = (arr) => arr.reduce((acc, item) => {
   acc[item.value] = item.title;
   return acc;
 }, {});

 export const labels = {
   ...employeeFieldLabels,
   ...projectFieldLabels,
   ...projectPurchaseOrderFieldLabels,
   ...workdayFieldLabels,
   ...workdayLineFieldLabels,
   ...workdaySummaryFieldLabels,
   ...calendarEventFieldLabels,
   ...genericLabels,
   ...entityLabels,
   ...countryHolidayFieldLabels,
   ...arrayToLabels(specialHoursTypes),
 };

export const languages = ['nl', 'de', 'es', 'en'];
